import {
    FETCH_RESOURCES_SUCCESS,
    FETCH_RESOURCES_ERROR,
    FETCH_RESOURCE_SUCCESS,
    FETCH_RESOURCE_ERROR,
    CREATE_RESOURCE_SUCCESS,
    CREATE_RESOURCE_ERROR,
    UPDATE_RESOURCE_SUCCESS,
    UPDATE_RESOURCE_ERROR,
    DELETE_RESOURCE_SUCCESS,
    DELETE_RESOURCE_ERROR,
  } from "./types";
  
  const initialState = {
    resources: [],
    resource: null,
    error: "",
  };
  
  export default function resourcesReducer(state = initialState, action) {
    switch (action.type) {
      case FETCH_RESOURCES_SUCCESS:
        return {
          ...state,
          resources: action.payload,
          error: "",
        };
      case FETCH_RESOURCES_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case FETCH_RESOURCE_SUCCESS:
        return {
          ...state,
          resource: action.payload,
          error: "",
        };
      case FETCH_RESOURCE_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case CREATE_RESOURCE_SUCCESS:
        return {
          ...state,
          resources: [...state.resources, action.payload],
          error: "",
        };
      case CREATE_RESOURCE_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case UPDATE_RESOURCE_SUCCESS:
        return {
          ...state,
          resources: state.resources.map((resource) =>
            resource._id === action.payload._id ? action.payload : resource
          ),
          error: "",
        };
      case UPDATE_RESOURCE_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      case DELETE_RESOURCE_SUCCESS:
        return {
          ...state,
          resources: state.resources.filter(
            (resource) => resource._id !== action.payload
          ),
          error: "",
        };
      case DELETE_RESOURCE_ERROR:
        return {
          ...state,
          error: action.payload,
        };
      default:
        return state;
    }
  }
  